import { Component, OnInit } from '@angular/core'
import { GlobalConstants } from 'src/app/constants/global-constants'
import {
  TASK_CURRENT_STATUS,
  QUERY_ID,
  QUERY_NAME,
  RAISED_ON,
  DAYS_ELAPSED,
  RESPONSE_DUE_BY,
  OWNER_DISPLAY_ID,
  COMPANY_ENTITY_DISPLAY_ID
} from 'src/app/constants/ui.columns'
import { QueriesAPIModel, StatusCountAPIModel, UserAPIModel } from 'src/app/models/api.model'
import { QueryService } from 'src/app/services/query/query.service'
import { QUERY_COMPLETED, QUERY_IN_PROGRESS, QUERIES_RECEIVED } from 'src/app/constants/stats-cards'
import { ViewForSelectorComponent } from '../../common/view-for-selector/view-for-selector.component'
import { Router } from '@angular/router'
import { InitializeService } from 'src/app/services/initialize/initialize.service'
import { Observable } from 'rxjs'

@Component({
  selector: 'app-query-dashboard',
  templateUrl: './query-dashboard.component.html',
  styleUrls: ['./query-dashboard.component.scss']
})
export class QueryDashboardComponent implements OnInit {
  readonly BUSINESS_SUMMARY = `/${GlobalConstants.ROUTING.QUERY}/${GlobalConstants.ROUTING.SUMMARY}`
  readonly routingLink = `/${GlobalConstants.ROUTING.QUERY}/{0}/${GlobalConstants.ROUTING.DETAILS}`
  pendingItemsList: QueriesAPIModel[] = []
  statusCountMap: StatusCountAPIModel[] = []
  pendingItemsTableColumns = [
    COMPANY_ENTITY_DISPLAY_ID,
    QUERY_ID,
    QUERY_NAME,
    OWNER_DISPLAY_ID,
    RAISED_ON,
    DAYS_ELAPSED,
    RESPONSE_DUE_BY,
    TASK_CURRENT_STATUS
  ]
  statsCards = [QUERIES_RECEIVED, QUERY_IN_PROGRESS, QUERY_COMPLETED]
  userType = GlobalConstants.USER_TYPE
  user$: Observable<UserAPIModel>

  constructor(
    private queryService: QueryService,
    private route: Router,
    private initializeService: InitializeService
  ) {}

  ngOnInit(): void {
    this.queryService.dispatchFetchQueryDashboardDataAction(
      ViewForSelectorComponent.defaultValue,
      GlobalConstants.SORT_COLUMN.CREATED_DATETIME,
      null
    )

    this.queryService.getQueryDashboardInfo().subscribe(queryDashboardInfo => {
      if (queryDashboardInfo) {
        this.pendingItemsList = queryDashboardInfo?.queriesPendingItemsList?.content
        this.statusCountMap = queryDashboardInfo?.statusCountMap
      }
    })

    this.user$ = this.initializeService.getUserFromState()
  }

  handleViewForData($event: any) {
    this.queryService.dispatchFetchQueryDashboardDataAction($event, 'createdDatetime', null)
  }

  viewSummary() {
    this.route.navigate([this.BUSINESS_SUMMARY])
  }
}
